
const packageJson = require('../package.json');

export function getVersionString() {
    return packageJson.version;
}

export function getAppName() {
    return `Analýzy historických dat ISKN`;
}

export function getAppNameWithVersion() {
    return `${getAppName()} v${getVersionString()}`;
}
